import { TPageName } from '../../../../shared/common/types/applicationContext';

export async function importApp(pageName: TPageName) {
  switch (pageName) {
    case 'card': {
      return (await import('../../../../shared/main/containers/MainApp')).MainApp;
    }

    case 'card-create': {
      return (await import('../../../../shared/createCard/containers/CreateCardApp')).CreateCardApp;
    }

    case 'card-render': {
      return (await import('../../../../shared/card/containers/CardApp')).CardApp;
    }

    default:
      throw new Error('Unknown context.custom.pageName');
  }
}
